export default __webpack_public_path__ + "static/media/cpv_16_farming-machines.191dc849.svg";